import { Product, ProductManufacturer } from "../Product/Product";
import { DmsManufacturer } from "../ShoppingPortal/DmsManufacturer";

export interface DealerLocation {
  id?: string;
  dealerId: number;
  dmsType: number;
  dmsLocationId: number;
  name: string;
  address: string;
  city: string;
  stateOrProvince: string;
  zipPostal: string;
  email: string;
  phone?: string;
  shopifyLocationId: number;
  isDefault: boolean;
}

export interface LocationPart {
  dealerId: string;
  inventoryPartId: string;
  manufacturerId: string;
  partNumber: string;
  description: string;
  price: number;
  availableQty: number;
  partNodash?: string;
  stockItem: boolean;
  locationCount: LocationPartCount[];
  averageCost: number;
  suggestedRetailPrice: number;
  mfrName?: string;
  mfrCode?: string;
}

export interface LocationWholegood {
  inventoryModelId: string;
  manufacturerId: string;
  model: string;
  modelId: number;
  price: number;
  cost: number;
  suggestedRetailPrice: number;
  unitListPrice_Largest: number;
  unitListPrice_Smallest: number;
  unitListPrice_Latest: number;
  unitListPrice_Largest_Stock: number;
  unitListPrice_Smallest_Stock: number;
  unitListPrice_Latest_Stock: number;
  msrpListPrice_Largest: number;
  msrpListPrice_Smallest: number;
  msrpListPrice_Latest: number;
  msrpListPrice_Largest_Stock: number;
  msrpListPrice_Smallest_Stock: number;
  msrpListPrice_Latest_Stock: number;
  description: string;
  productLine: string;
  subProduct: string;
  stockItem: boolean;
  locationCount: LocationWholegoodCount[];
  mfrCode?: string;
  mfgName?: string;
}

export interface LocationWholegoodCount {
  locationId: number;
  count: number;
  locationTitle?: string;
}

export interface LocationPartCount {
  locationId: number;
  count: number;
  locationTitle?: string;
}

export interface DmsSetupState {
  wholegoods: {
    items: LocationWholegood[];
    matchedItems: LocationWholegood[];
    misMatchedItems: LocationWholegood[];
  };
  parts: LocationPart[];
  itemTypes: string[];
  matchedProducts: MatchedProduct[];
  missMatchedProducts: LocationWholegood[];
  missMatchedParts: LocationPart[];
  locationIds: string[];
  typeToProcess: string[];
  stocking: boolean;
  withQtyOnly: boolean;
  shopifyAccessToken?: string;
  shopifyUrl?: string;
  isSyncing?: boolean;
  dmsWholeGoods: LocationWholegood[];
  dmsParts?: LocationPart[];
  dealerManufacturers: ProductManufacturer[];
  syncedProductAggregateEventData?: any;
  mappedLocations: DealerLocation[];
  dmsManufacturers: DmsManufacturer[];
}

export interface MatchedProduct {
  dmsProduct?: LocationWholegood;
  dmsPart?: LocationPart;
  catalogProduct?: Product;
  isManuallyMatched?: boolean;
}

export interface NotSyncedResponse {
  wholegoods: LocationWholegood[];
  parts: LocationPart[];
}

export interface MatchedProductRes {
  dmsProduct?: LocationWholegood;
  catalogPorduct?: Product;
}
export interface DmsSyncStatusRequest {
  entityId: string;
  isDisable: boolean;
  entityType: EntityType;
  disableOption: DisableOption;
}
export interface GetWGSerialRequest {
  dealerIds: string[];
  model: string;
  mfrCode: string;
  everestDmsDealerId: string;
}
export enum ProductType {
  Whoolgoods = 0,
  Parts = 1,
}
export enum PricingType {
  Price = 0,
  RetailPrice = 1,
  UnitListPriceLargestStock = 2,
  UnitListPriceSmallestStock = 3,
  UnitListPriceLatestStock = 4,
  MSRPListPriceLargestStock = 5,
  MSRPListPriceSmallestStock = 6,
  MSRPListPriceLatestStock = 7,
  MSRPListPriceLargest = 8,
  MSRPListPriceSmallest = 9,
  MSRPListPriceLatest = 10,
  UnitListPriceLargest = 11,
  UnitListPriceSmallest = 12,
  UnitListPriceLatest = 13,
  UnitPrice = 14,
}
export enum DisableOption {
  Price,
  Stock,
  Catalog,
}
export enum EntityType {
  DmsSetup,
  ProductAggregate,
}

export enum UnitPriceType {
  UnitList,
  MSRPList,
}

export enum PurchaseUnit {
  EA = "EA",
  FT = "FT",
  PKG = "PKG",
  CD = "CD",
  BAG = "BAG",
  RL = "RL",
  CS = "CS",
  GAL = "GAL",
  CTN = "CTN",
  PL = "PL",
  BX = "BX",
  DSP = "DSP",
  ROW = "ROW",
  PR = "PR",
  PGK = "PGK",
  SET = "SET",
  LB = "LB",
  C = "C",
  M = "M",
  WKT = "WKT",
  DZ = "DZ",
  Pcs = "Pcs",
  PCE = "PCE",
}

export enum DmsSetupDefaultType {
  ShippingItem,
}
